const universities = {
  DIET: {
    courses: ['B.Tech. Civil', 'B.Tech. Computer', 'B.Tech. Mechanical', 'M.Tech. Software', 'M.Tech. Structural', 'M.Tech. Transportation', 'M.Tech. Thermal', 'M.Tech. Construction Project Management', 'M.Tech. Advanced Design & Manufacturing', 'Ph.D. CSE', 'Ph.D. Civil', 'Ph.D. Mechanical'],
  },
  DIETDS: {
    courses: ['Computer', 'Civil', 'Electrical', 'Mechanical'],
  },
  DICA: {
    courses: ['BCA', 'MCA', 'B.Sc.(IT)', 'B.Sc. Honors(CS)'],
  },
  DIM: {
    courses: ['MBA', 'BBA', 'BBA-DM', 'B.Com', 'B.Com (Hons.)', 'Ph.D.'],
  },
  DIS: {
    courses: ['B.Sc. (Microbiology)', 'Ph.D. (Microbiology)'],
  },
  DIH: {
    courses: ['M.A. (Yoga)'],
  },
};

const games = {
  Chess: {
    isTeamGame: false,
  },
  Badminton: {
    isTeamGame: false,
  },
  Yoga: {
    isTeamGame: false,
  },
  '100 Meter': {
    isTeamGame: false,
  },
  '200 Meter': {
    isTeamGame: false,
  },
  '400 Meter': {
    isTeamGame: false,
  },
  'Javelin Throw': {
    isTeamGame: false,
  },
  'Shot Put': {
    isTeamGame: false,
  },
  'Discus Throw': {
    isTeamGame: false,
  },
  'Rifle Shooting': {
    isTeamGame: false,
  },
  'Table Tennis': {
    isTeamGame: false,
  },
  Cricket: {
    isTeamGame: true,
    minPlayers: 11,
    maxPlayers: 16,
  },
  Football: {
    isTeamGame: true,
    minPlayers: 2,
    maxPlayers: 5,
  },
  Volleyball: {
    isTeamGame: true,
    minPlayers: 6,
    maxPlayers: 12,
  },
  Kabaddi: {
    isTeamGame: true,
    minPlayers: 7,
    maxPlayers: 12,
  },
  Basketball: {
    isTeamGame: true,
    minPlayers: 5,
    maxPlayers: 15,
  },
  'Tug of war': {
    isTeamGame: true,
    minPlayers: 4,
    maxPlayers: 9,
  },
  'Kho-Kho': {
    isTeamGame: true,
    minPlayers: 7,
    maxPlayers: 9,
  },
};

function getCoursesByUniversity(university) {
  return universities[university]?.courses || [];
}

const TEAM_SPORTS = [
  {
    name: "Cricket",
    teamSize: 16,
    minPlayers: 11,
    link: "https://drive.google.com/file/d/1kN9nDLWv8aPpnis8lBjjEPvB2XJyuAHL/view?usp=drive_link",
  },
  {
    name: "Football",
    teamSize: 12,
    minPlayers: 2,
    link: "https://drive.google.com/file/d/17B7YBL1ZIAOD74fkMZdj2lEw38g7IRXW/view?usp=drive_link",
  },
  {
    name: "Volleyball",
    teamSize: 12,
    minPlayers: 6,
    link: "https://drive.google.com/file/d/1ejBnudWLxLBoBjAJk7ZwBDU8jt8Vn0QK/view?usp=drive_link",
  },
  {
    name: "Kabaddi",
    teamSize: 12,
    minPlayers: 7,
    link: "https://drive.google.com/file/d/1Ej52sgNBbMC5qub43jWoJt2Kl0RDzW3J/view?usp=drive_link",
  },
  {
    name: "Basketball",
    teamSize: 15,
    minPlayers: 5,
    link: "https://drive.google.com/file/d/1idJV1HD91uLR4XQd2JBn6bWxOzWvmHrR/view?usp=drive_link",
  },
  {
    name: "Tug of war",
    teamSize: 9,
    minPlayers: 4,
    link: ""
  },
  {
    name: "Kho-Kho",
    teamSize: 9,
    minPlayers: 7,
    link: "https://drive.google.com/file/d/1n2LQjEOFOAkSkR9BQlmVaf-K9merVrXe/view?usp=drive_link",
  },
];

const T_SHIRT_SIZES = ["XS", "S", "M", "L", "XL", "XXL"];
const SEMESTERS = Array.from({ length: 8 }, (_, i) => String(i + 1));

const constants = {
  games,
  gameNames: Object.keys(games),
  teamGameNames: Object.keys(games).filter((g) => games[g].isTeamGame),

  universities,
  universityNames: Object.keys(universities),
  getCoursesByUniversity,

};

export {
  constants,
  TEAM_SPORTS,
  T_SHIRT_SIZES,
  SEMESTERS,
};
